import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import InsightCard from './InsightCard';

const Insights: React.FC = () => {
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();

    const scrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: -489, // Card width (457) + gap (32)
                behavior: 'smooth'
            });
        }
    };

    const scrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({
                left: 489, // Card width (457) + gap (32)
                behavior: 'smooth'
            });
        }
    };
    const insightData = [
        {
            image: "/carousel/image1.png",
            webpImage: "/carousel/image1.webp",
            placeholder: "/carousel/image1-placeholder.jpg",
            category: "AI in Recruiting",
            title: "Discover how smart automation is connecting companies with the hidden 70% of passive candidates.",
            description: ""
        },
        {
            image: "/carousel/image2.png",
            webpImage: "/carousel/image2.webp",
            placeholder: "/carousel/image2-placeholder.jpg",
            category: "Hiring Insights",
            title: "5 Common Mistakes Recruiters Make — and How to Avoid Them",
            description: ""
        },
        {
            image: "/carousel/image3.png",
            webpImage: "/carousel/image3.webp",
            placeholder: "/carousel/image3-placeholder.jpg",
            category: "Cutting Recruiting Costs",
            title: "How smarter matching reduces fees and delivers better hires.",
            description: ""
        },
        {
            image: "/carousel/image4.png",
            webpImage: "/carousel/image4.webp",
            placeholder: "/carousel/image4-placeholder.jpg",
            category: "The Power of Passive Candidates",
            title: "Why professionals who aren't actively job hunting have the upper hand.",
            description: ""
        },
        {
            image: "/carousel/image.png",
            category: "Remote Hiring in 2025",
            title: "How companies are reshaping their strategies for a global workforce.",
            description: ""
        }
    ];

    return (
        <section className="relative pt-4 pb-4 px-[22px] sm:px-4 sm:pt-16 overflow-x-hidden">
            {/* Title Section - Constrained */}
            <div className="container mx-auto max-w-[1600px] relative z-10 mb-12 sm:mb-20 sm:px-16">
                {/* Title and Subtitle Section - Same as Meet David */}
                <div>
                    {/* Title - Mobile responsive */}
                    <h2 className="text-white mb-4 sm:mb-8 text-[28px] leading-[36px] sm:!text-[clamp(48px,6vw,96px)] sm:!leading-[clamp(56px,7vw,110px)]" style={{
                        fontFamily: 'Manrope',
                        fontWeight: 700,
                        letterSpacing: '-0.05em'
                    }}>
                        Insights & Resources
                    </h2>

                    {/* Subtitle - Full width on mobile, right-aligned on desktop */}
                    <div className="sm:flex sm:justify-end">
                        <p className="text-white text-[14px] leading-[20px] sm:!text-[clamp(16px,2vw,32px)] sm:!leading-[clamp(24px,2.5vw,44px)] sm:max-w-[80%]" style={{
                            fontFamily: 'Manrope',
                            fontWeight: 200,
                            letterSpacing: '-0.05em',
                            textAlign: 'justify'
                        }}>
                            Stay ahead with the latest on AI recruiting, hiring trends, and career growth.
                        </p>
                    </div>
                </div>
            </div>

            {/* Carousel container - Full width, extends to right edge */}
            <div className="relative w-full">
                <style>
                    {`
                        .carousel-scroll::-webkit-scrollbar {
                            display: none;
                        }
                    `}
                </style>

                {/* Navigation Buttons - Hidden on mobile */}
                <div className="hidden sm:flex absolute right-16 -top-32 z-20 gap-4">
                    <button
                        onClick={scrollLeft}
                        className="flex items-center justify-center transition-all hover:scale-110"
                        style={{
                            width: '48px',
                            height: '48px',
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            borderRadius: '50%',
                            backdropFilter: 'blur(10px)',
                            cursor: 'pointer'
                        }}
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <button
                        onClick={scrollRight}
                        className="flex items-center justify-center transition-all hover:scale-110"
                        style={{
                            width: '48px',
                            height: '48px',
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            borderRadius: '50%',
                            backdropFilter: 'blur(10px)',
                            cursor: 'pointer'
                        }}
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>

                <div
                    ref={scrollContainerRef}
                    className="carousel-scroll flex overflow-x-auto pb-4 sm:pb-8 snap-x snap-mandatory gap-4 sm:gap-8"
                    style={{
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        scrollBehavior: 'smooth',
                        WebkitOverflowScrolling: 'touch',
                        paddingLeft: '22px'
                    }}
                >
                    {insightData.map((insight, index) => (
                        <div key={index} className="snap-center flex-shrink-0">
                            <InsightCard
                                {...insight}
                                onReadMore={() => {
                                    navigate('/blog');
                                    window.scrollTo(0, 0);
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Insights;
